export const TYPE_CHAT_STREAM_START="chat/TYPE_CHAT_STREAM_START";
export const TYPE_CHAT_STREAM_UPDATE="chat/TYPE_CHAT_STREAM_UPDATE";
export const TYPE_CHAT_SUCCESS="chat/TYPE_CHAT_SUCCESS";
export const TYPE_CHAT_FAILURE="chat/TYPE_CHAT_FAILURE";
export const TYPE_CHAT_CLEAR = "chat/TYPE_CHAT_CLEAR";
export const CHAT_HISTORY_ONE_SUCCESS="chat/CHAT_HISTORY_ONE_SUCCESS";
export const CHAT_HISTORY_ONE_FAILURE = "chat/CHAT_HISTORY_ONE_FAILURE";
export const CHAT_HISTORY_SEVEN_SUCCESS="chat/CHAT_HISTORY_SEVEN_SUCCESS";
export const CHAT_HISTORY_SEVEN_FAILURE = "chat/CHAT_HISTORY_SEVEN_FAILURE";
export const CHAT_HISTORY_MONTH_SUCCESS="chat/CHAT_HISTORY_MONTH_SUCCESS";
export const CHAT_HISTORY_MONTH_FAILURE = "chat/CHAT_HISTORY_MONTH_FAILURE";
// export const ANSWER_SPEAKER_SUCCESS="chat/ANSWER_SPEAKER_SUCCESS";
// export const ANSWER_SPEAKER_FAILURE = "chat/ANSWER_SPEAKER_FAILURE";

